import React, { useEffect, useState } from 'react'
import Card from './Card'

const Tab = () => {
    const [current, setCurrent] = useState();
    useEffect(() => {
        setCurrent("1")
    }, [])


    const tabs = [
        {
            id: 1,
            tabtitle: 'Apps',
            content: [
                {
                    id: 1,
                    contentTitle: "File Transmorpher",
                    about: "Our mission is to empower you to effortlessly convert your files between different formats, saving you time and frustration all at absolutely no cost!.",
                    image: require('../assets/f-transmorpher.png'),
                    link: 'https://file-transmorpher.vercel.app'
                },
                {
                    id: 2,
                    contentTitle: "Walkie Talkie",
                    about: "",
                    image: "",
                    link: ''
                },
                {
                    id: 3,
                    contentTitle: "Sorting Visualiser",
                    about: "This visualizer lets you see different sorting algorithms in action.  Choose an algorithm and watch it sort data visually. It's a great way to understand how each algorithm works and compare their efficiency.",
                    image: require('../assets/visualiser.png'),
                    link: 'https://sorting-visuals.surge.sh/'
                }
            ]

        },
        {
            id: 2,
            tabtitle: 'Solutions',
            content: [
                {
                    id: 1,
                    contentTitle: "P-notion",
                    about: "",
                    image: require('../assets/p-notion.png'),
                    link: 'https://p-notion.vercel.app'
                },
                {
                    id: 2,
                    contentTitle: "Real Estate",
                    about: "",
                    image: "",
                    link: ''
                },
                {
                    id: 3,
                    contentTitle: "GenKonnect",
                    about: "",
                    image: require('../assets/genkonnect.png'),
                    link: ''
                }
            ]
        },
        {
            id: 3,
            tabtitle: 'Side Projects',
            content: [
                {
                    id: 1,
                    contentTitle: "Death Note Diary",
                    about: "",
                    image: require('../assets/dnd.png'),
                    link: 'https://death-note-diary.vercel.app/'

                },
                {
                    id: 2,
                    contentTitle: "Match-Mania",
                    about: "",
                    image: require('../assets/m-m.png'),
                    link: 'https://match-mania.tiiny.site/'

                },
                {
                    id: 3,
                    contentTitle: "Sorting Visualiser",
                    about: "",
                    image: "",
                    link: ''
                }
            ]
        },
    ]
    const handleClick = (e) => {
        setCurrent(e.target.id)
        console.log(e.target);
    }
    return (
        <section className='flex flex-col lg:flex-row gap-y-6 gap-x-4 md:gap-x-6 justify-between w-full h-full'>
            <div className={'flex justify-center flex-row lg:flex-col gap-x-2 lg:gap-y-8 h-full w-full lg:w-1/12 '}>
                {tabs.map((tab, i) =>
                    <button
                        key={i}
                        id={tab.id}
                        disabled={current === `${tab.id}`}
                        onClick={(handleClick)}
                        className={`border p-6 lg:p-4 rounded-lg hover:scale-110 ${current === `${tab.id}` ? 'shadow-[0px_0px_10px_5px] shadow-pink-700 scale-110' : ''}`}
                    >
                        {tab.tabtitle}
                    </button>
                )}
            </div>
            <div className='flex items-center justify-center w-11/12   h-full'>
                {tabs.map((tab, i) => (
                    current === `${tab.id}` && ( // Return the content if current matches
                        <div key={i} className='grid md:grid-cols-2 grid-col-1 lg:grid-cols-3 gap-6 lg:gap-5 place-items-center justify-center w-full text-xs'>
                            {tab.content.map((tabContent, j) => (

                                <Card id={tabContent.id} about={tabContent.about} title={tabContent.contentTitle} image={tabContent.image} link={tabContent.link} />

                            ))}
                        </div>
                    )
                ))}
            </div>
        </section>
    )
}

export default Tab